// franchise agreement
import Agreement1 from '@/components/Terms/FranchiseAgreement/Agreement1.vue';
import Agreement2 from '@/components/Terms/FranchiseAgreement/Agreement2.vue';
import Agreement3 from '@/components/Terms/FranchiseAgreement/Agreement3.vue';
import Agreement4 from '@/components/Terms/FranchiseAgreement/Agreement4.vue';
import Agreement5 from '@/components/Terms/FranchiseAgreement/Agreement5.vue';
import Agreement6 from '@/components/Terms/FranchiseAgreement/Agreement6.vue';
import Agreement7 from '@/components/Terms/FranchiseAgreement/Agreement7.vue';
import Agreement8 from '@/components/Terms/FranchiseAgreement/Agreement8.vue';
import Agreement9 from '@/components/Terms/FranchiseAgreement/Agreement9.vue';
import Agreement10 from '@/components/Terms/FranchiseAgreement/Agreement10.vue';
import Agreement11 from '@/components/Terms/FranchiseAgreement/Agreement11.vue';
import Agreement12 from '@/components/Terms/FranchiseAgreement/Agreement12.vue';
import Agreement13 from '@/components/Terms/FranchiseAgreement/Agreement13.vue';

// guideline
import Guide1 from '@/components/Terms/Guideline/Guideline1.vue';
import Guide2 from '@/components/Terms/Guideline/Guideline2.vue';

// legal indication
import Legal1 from '@/components/Terms/LegalIndication/LegalIndication1.vue';
import Legal2 from '@/components/Terms/LegalIndication/LegalIndication2.vue';
import Legal3 from '@/components/Terms/LegalIndication/LegalIndication3.vue';
import Legal4 from '@/components/Terms/LegalIndication/LegalIndication4.vue';
import Legal5 from '@/components/Terms/LegalIndication/LegalIndication5.vue';
import Legal6 from '@/components/Terms/LegalIndication/LegalIndication6.vue';
import Legal7 from '@/components/Terms/LegalIndication/LegalIndication7.vue';
import Legal8 from '@/components/Terms/LegalIndication/LegalIndication8.vue';

// privacy policy
import Privacy1 from '@/components/Terms/PrivacyPolicy/PrivacyPolicy1.vue';
import Privacy2 from '@/components/Terms/PrivacyPolicy/PrivacyPolicy2.vue';
import Privacy3 from '@/components/Terms/PrivacyPolicy/PrivacyPolicy3.vue';

// url for franchise
export const FRANCHISE_URL = '/terms/terms/franchise_agreement';
// url for guideline
export const GUIDELINE_URL = '/terms/terms/guideline';
// url for legal indication
export const LEGAL_URL = '/terms/terms/legal_indication';
// url for privacy policy
export const PRIVACY_URL = '/terms/terms/privacy_policy';

export const SIDEBAR_MENUS_TERMS = [
	{
		section: 'Franchise Agreement',
		items: [
			{
				key: 'franchise-home',
				label: 'Merchant Terms & Conditions (For Online Payment)',
				component: Agreement1,
				url: FRANCHISE_URL,
			},
			{
				key: 'franchise-profile',
				label: 'Online Payment API Usage Special Agreement',
				component: Agreement2,
				url: FRANCHISE_URL,
			},
			{
				key: 'franchise-messages',
				label: 'Balance Terms & Conditions (For Online Payment)',
				component: Agreement3,
				url: FRANCHISE_URL,
			},
			{
				key: 'franchise-settings',
				label:
					'Credit Card Merchant Terms & Conditions (For Mail-order Merchants)',
				component: Agreement4,
				url: FRANCHISE_URL,
			},
			{
				key: 'franchise-creditcard',
				label:
					'JPWorldPay For Business Terms & Conditions (For Online Payment)',
				component: Agreement5,
				url: FRANCHISE_URL,
			},
			{
				key: 'franchise-postpaid',
				label: 'Postpaid Merchant Terms & Conditions (For Online Payment)',
				component: Agreement6,
				url: FRANCHISE_URL,
			},
			{
				key: 'franchise-datausage',
				label: 'Data Usage Special Agreement',
				component: Agreement7,
				url: FRANCHISE_URL,
			},
			{
				key: 'franchise-agreement',
				label: 'Special Agreement On Payment For Products etc.',
				component: Agreement8,
				url: FRANCHISE_URL,
			},
			{
				key: 'franchise-prepaid',
				label: 'Special Agreement On The Handling Of Prepaid Services',
				component: Agreement9,
				url: FRANCHISE_URL,
			},
			{
				key: 'franchise-merchant',
				label: 'Merchant Terms & Conditions (For Mini App)',
				component: Agreement10,
				url: FRANCHISE_URL,
			},
			{
				key: 'franchise-specagreement',
				label: 'Data Use Special Agreement (For Mini App)',
				component: Agreement11,
				url: FRANCHISE_URL,
			},
			{
				key: 'franchise-establish',
				label: 'The Establishment Of A Contract',
				component: Agreement12,
				url: FRANCHISE_URL,
			},
			{
				key: 'franchise-joint',
				label: 'About Joint Use Of Merchant Information',
				component: Agreement13,
				url: FRANCHISE_URL,
			},
		],
	},
	{
		section: 'The Guideline',
		items: [
			{
				key: 'guideline-guide1',
				label: 'Merchant Guidelines (For Mini App)',
				component: Guide1,
				url: GUIDELINE_URL,
			},
			{
				key: 'guideline-guide2',
				label: 'Merchant Guidelines (For Online Payments)',
				component: Guide2,
				url: GUIDELINE_URL,
			},
		],
	},
	{
		section: 'Legal Indication',
		items: [
			{
				key: 'legal-legal1',
				label: 'Banking Agent Overview',
				component: Legal1,
				url: LEGAL_URL,
			},
			{
				key: 'legal-legal2',
				label: 'Handling Product Card Loan Individual Interest Rate etc.',
				component: Legal2,
				url: LEGAL_URL,
			},
			{
				key: 'legal-legal3',
				label: 'Handling Product Card Loan Individual Product Brief',
				component: Legal3,
				url: LEGAL_URL,
			},
			{
				key: 'legal-legal4',
				label: 'Yen Ordinary Deposit Account Interest Rate etc.',
				component: Legal4,
				url: LEGAL_URL,
			},
			{
				key: 'legal-legal5',
				label: 'Yen Ordinary Deposit Account Product Overview',
				component: Legal5,
				url: LEGAL_URL,
			},
			{
				key: 'legal-legal6',
				label: 'Handling Product Business Loan Interest Rate etc.',
				component: Legal6,
				url: LEGAL_URL,
			},
			{
				key: 'legal-legal7',
				label: 'Handling Product Business Loan Product Brief',
				component: Legal7,
				url: LEGAL_URL,
			},
			{
				key: 'legal-legal8',
				label:
					'About The Applicable Interest Rate In Case Of Multiple Contracts With The Company',
				component: Legal8,
				url: LEGAL_URL,
			},
		],
	},
	{
		section: 'Privacy Policy',
		items: [
			{
				key: 'privacy-privacy1',
				label: 'Request For Disclosure Of Personal Information',
				component: Privacy1,
				url: PRIVACY_URL,
			},
			{
				key: 'privacy-privacy2',
				label: 'About User Security',
				component: Privacy2,
				url: PRIVACY_URL,
			},
			{
				key: 'privacy-privacy3',
				label: 'Affiliated Company',
				component: Privacy3,
				url: PRIVACY_URL,
			},
		],
	},
];
